export default {
  type: 'Type',
  code: 'Code',
  typePlaceholder: 'Select type',
  codePlaceholder: 'Enter code',
  AIRPORT: 'Airport',
  CARRIER: 'Carrier',
  CITY: 'City',
  COUNTRY: 'Country',
  EQUIPMENT: 'Equipment',
  TIMESTAMP: 'Timestamp',
  result: 'Result',
  noResult: 'Not found any result',
  cityCode: 'City code',
  countryCode: 'Country code',
  name: 'Name',

  currencyConversion: 'Currency conversion',
  amount: 'Amount',
  amountPlaceHolder: 'Enter amount',
  from: 'From',
  to: 'To',
  convert: 'Convert',
  bankSellingRate: 'Bank selling rate',
  convertedAmount: 'Converted amount',
  description: 'Description',

  flightsSchedule: {
    title: 'Flights schedule',
    columns: {
      scheduleTime: 'Schedule Time',
      estimateTime: 'Estimate Time',
      airportNameA: 'From',
      airportNameD: 'To',
      airlineName: 'Airline',
      flightNumber: 'Flight Number',
      gateA: 'Luggage',
      gateD: 'Gate',
      Trễ: 'light-danger',
      'Đang lên máy bay': 'light-warning',
      terminal: 'Terminal',
      checkinRow: 'Checkin row',
      remark: 'Remark',
    },
    filters: {
      stationType: 'Station type',
      tripType: 'Trip type',
      departure: 'Airport',
      departureDate: 'Date',
      departureHour: 'Time',
    },
    stationType: {
      DOM: 'Domestic',
      INT: 'International',
    },
    tripType: {
      Arrival: 'Arrival',
      Departure: 'Departure',
    },
    airport: {
      HAN: 'Hanoi',
      SGN: 'Ho Chi Minh',
      DAD: 'Da Nang',
      CXR: 'Nha Trang',
    },
    remark: {
      'Hủy chuyến bay': 'Cancel',
      'Đã cất cánh': 'Departed',
      'Đã hạ cánh': 'Landed',
      'Đang đến': 'Arrival',
      'Mở quầy thủ tục': 'Check-in open',
      'Lên tàu bay': 'Boarding',
      'Sắp cất cánh': 'Waiting for take off',
      'Sắp hạ cánh': 'Landing',
      'Chuyến bay đến trễ': 'Delay',
      // tpv
      // SGN
      'Đóng cửa khởi hành': 'Close boarding gate',
      'Hành khách cuối lên tàu bay': 'Last passenger on boarding',
      'Hành khách lên tàu bay': 'Boarding',
      'Mời hành khách làm thủ tục': 'Check-in open',
      'Đổi cửa khởi hành': 'Change boarding gate',
      'Đến trễ': 'Delay',
      'Hành khách cuối làm thủ tục': 'Last passenger check-in',
      'Ðang trả hành lý': 'Baggage claim in progress',

      // DAD
      Trễ: 'Delay',
      'Đang lên máy bay': 'Boarding',
    },
    msg: {
      errorFetching: 'Error fetching data, please try again.',
    },
  },
}
